module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Name":"Nom du programmeur","StartDate":"Date de début","EndDate":"Date de fin"}}')
  delete Component.options._Ctor
}
